module.exports = __webpack_public_path__ + "media/images/v2/kwivrr-stream-icon-ff53ba44c3308a0f81d47ba118492a98.png";